import { render, staticRenderFns } from "./Barcode.vue?vue&type=template&id=332d1066"
import script from "./Barcode.vue?vue&type=script&lang=js"
export * from "./Barcode.vue?vue&type=script&lang=js"
import style0 from "./Barcode.vue?vue&type=style&index=0&id=332d1066&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports